module.exports = __webpack_public_path__ + "img/Cattering & canteen services.2bbef6ba.png";